// extracted by mini-css-extract-plugin
export default {"container":"summary-description_container__iuP0w"};